import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../pages/home'

import user from '../pages/user/user'
import userLogin from '../pages/user/login'
import userRegister from '../pages/user/register'

import userDashboard from '../pages/user/dashboard/dashboard'
import userDashboardPersonalInformation from '../pages/user/dashboard/personal-information'
import userDashboardChangePassword from '../pages/user/dashboard/change-password'
import userDashboardPathsSaved from '../pages/user/dashboard/paths-saved'
import userDashboardFavorites from '../pages/user/dashboard/favorites'

import admin from '../pages/admin/admin'
import adminCalendar from '../pages/admin/calendar'
import adminCalendarItem from '../pages/admin/calendarItem'
import adminActivities from '../pages/admin/activities'
import adminActivityItem from '../pages/admin/activityItem'
import adminInterestPoints from '../pages/admin/interestPoints'
import adminInterestPoint from '../pages/admin/interestPoint'
import adminPaths from '../pages/admin/paths'
import adminPath from '../pages/admin/path'

import adminSliders from '../pages/admin/sliders'
import adminSlider from '../pages/admin/slider'

import estalagem from '../pages/estalagem'
import patrimonio from '../pages/patrimonio'
import pontosDeInteresse from '../pages/pontos-de-interesse'
import pontoDeInteresse from '../pages/ponto-de-interesse'
import eventosActividade from '../pages/eventos-e-actividades'
import evento from '../pages/evento'
import informacaoGeral from '../pages/informacao-geral'
import percursos from '../pages/percursos'
import percurso from '../pages/percurso'
import politicas from '../pages/politicas'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: home
  },
  {
    path: '/user',
    name: 'user',
    component: user,
    children: [
      {
        path: '/user/login',
        name: 'userLogin',
        component: userLogin
      },
      {
        path: '/user/register',
        name: 'userRegister',
        component: userRegister
      },
      {
        path: '/user/dashboard',
        name: 'userDashboard',
        component: userDashboard,
        children: [
          {
            path: '/user/dashboard/informacao-pessoal',
            name: 'informacaoPessoal',
            component: userDashboardPersonalInformation
          },
          {
            path: '/user/dashboard/alterar-password',
            name: 'informacaoPessoal',
            component: userDashboardChangePassword
          },
          {
            path: '/user/dashboard/percursos-guardados',
            name: 'informacaoPessoal',
            component: userDashboardPathsSaved
          },
          {
            path: '/user/dashboard/favoritos',
            name: 'informacaoPessoal',
            component: userDashboardFavorites
          }
        ]
      }
    ]
  },
  {
    path: '/admin',
    name: 'admin',
    component: admin,
    children: [
      {
        path: '/admin/interestPoints',
        name: 'adminInterestPoints',
        component: adminInterestPoints
      },
      {
        path: '/admin/interestPoint/:id',
        name: 'adminInterestPoint',
        component: adminInterestPoint,
        props: true
      },
      {
        path: '/admin/calendar',
        name: 'adminCalendar',
        component: adminCalendar
      },
      {
        path: '/admin/calendarItem/:id',
        name: 'adminCalendarItem',
        component: adminCalendarItem
      },
      {
        path: '/admin/activities',
        name: 'adminActivities',
        component: adminActivities
      },
      {
        path: '/admin/activityItem/:id',
        name: 'adminActivityItem',
        component: adminActivityItem
      },
      {
        path: '/admin/paths',
        name: 'adminPaths',
        component: adminPaths
      },
      {
        path: '/admin/path/:id',
        name: 'adminPath',
        component: adminPath,
        props: true
      },
      {
        path: '/admin/sliders',
        name: 'adminSliders',
        component: adminSliders
      },
      {
        path: '/admin/slider/:id',
        name: 'adminSlider',
        component: adminSlider,
        props: true
      },
    ]
  },
  {
    path: '/estalagem',
    name: 'estalagem',
    component: estalagem
  },
  {
    path: '/patrimonio',
    name: 'patrimonio',
    component: patrimonio
  },
  {
    path: '/pontosDeInteresse',
    name: 'pontos_de_interesse',
    component: pontosDeInteresse
  },
  {
    path: '/pontoDeInteresse/:id',
    name: 'ponto_de_interesse',
    component: pontoDeInteresse,
    props: true
  },
  {
    path: '/eventosActividade',
    name: 'eventos_e_atividade',
    component: eventosActividade
  },
  {
    path: '/evento/:id',
    name: 'evento',
    component: evento,
    props: true
  },
  {
    path: '/percursos',
    name: 'percursos',
    component: percursos
  },
  {
    path: '/percurso/:id',
    name: 'percurso',
    component: percurso,
    props: true
  },
  {
    path: '/informacaoGeral',
    name: 'informacao_geral',
    component: informacaoGeral
  },
  {
    path: '/politicaPrivacidadeECookies',
    name: 'politicaPrivacidadeECookies',
    component: politicas
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
